<template>
    <footer class="au-footer">
        {{ $t("nav.footer", { year }) }}
    </footer>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    data() {
        return {
            year: new Date().getFullYear(),
        };
    },
});
</script>
